import Swiper from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { EffectCoverflow, Keyboard, Navigation, Pagination, Scrollbar } from "swiper/modules";
export function initLightBoxSlider() {
    var lightBoxBlur = document.querySelector('.lightBoxBlur');
    var lightBoxZoom = document.querySelector('.lightBoxZoom');
    var lightBoxZoomClose = document.querySelector('.lightBoxZoomClose');
    var lightBoxCloseModal = document.querySelector('.lightBoxCloseModal');
    var openZoom = document.querySelectorAll('.swiper-slide-openZoom');
    var lightBoxButtonNormal = document.querySelector('.lb-buttons-normal');
    if (lightBoxBlur && lightBoxZoom) {
        document.body.append(lightBoxBlur, lightBoxZoom);
    }
    lightBoxZoom === null || lightBoxZoom === void 0 ? void 0 : lightBoxZoom.querySelectorAll('.image-wrapper img').forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) {
            img.classList.add('is-loaded');
        }
        else {
            img.addEventListener('load', function () { return img.classList.add('is-loaded'); }, { once: true });
        }
    });
    if (lightBoxZoomClose != null) {
        lightBoxCloseModal.addEventListener("click", function (event) {
            lightBoxBlur.classList.toggle("lightBoxBlurHide");
            lightBoxButtonNormal.classList.remove("lightBoxButtonsHide");
            lightBoxZoom.classList.add("lightBoxZoomHide");
            document.documentElement.classList.remove("lightbox-open");
        });
        lightBoxZoomClose.addEventListener("click", function (event) {
            lightBoxBlur.classList.toggle("lightBoxBlurHide");
            lightBoxButtonNormal.classList.remove("lightBoxButtonsHide");
            lightBoxZoom.classList.add("lightBoxZoomHide");
            document.documentElement.classList.remove("lightbox-open");
        });
        document.addEventListener("keydown", function (event) {
            if (event.key === "Escape") {
                lightBoxBlur.classList.add("lightBoxBlurHide");
                lightBoxButtonNormal.classList.remove("lightBoxButtonsHide");
                lightBoxZoom.classList.add("lightBoxZoomHide");
                document.documentElement.classList.remove("lightbox-open");
            }
        });
        if (openZoom && openZoom.length > 0) {
            openZoom.forEach(function (slide) {
                slide.addEventListener("click", function (event) {
                    var slideId = Number(slide.getAttribute('slide-id'));
                    if (!isNaN(slideId)) {
                        swiperZoom.slideTo(slideId);
                    }
                    lightBoxBlur.classList.toggle("lightBoxBlurHide");
                    lightBoxButtonNormal.classList.add("lightBoxButtonsHide");
                    lightBoxZoom.classList.remove("lightBoxZoomHide");
                    document.documentElement.classList.add("lightbox-open");
                });
            });
        }
    }
    var swiperNormal = new Swiper(".lightbox-normal", {
        modules: [Navigation, Pagination, Scrollbar, EffectCoverflow, Keyboard],
        initialSlide: 0,
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
            nextEl: ".lb-normal-next",
            prevEl: ".lb-normal-prev",
        },
        scrollbar: {
            el: ".swiper-scrollbar-normal",
            enabled: true,
            draggable: true,
            hide: false,
            horizontalClass: "lb-normal-scrollbar"
        },
        autoHeight: false,
        loop: false,
        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
        breakpoints: {
            768: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 2,
            },
            1280: {
                slidesPerView: 3,
            }
        }
    });
    var swiperZoom = new Swiper(".lightbox-zoom", {
        modules: [Navigation, Pagination, Scrollbar, EffectCoverflow, Keyboard],
        initialSlide: 0,
        direction: 'horizontal',
        spaceBetween: 30,
        slidesPerView: 1,
        navigation: {
            nextEl: ".lb-zoom-next",
            prevEl: ".lb-zoom-prev",
        },
        scrollbar: {
            el: ".swiper-scrollbar-zoom",
            enabled: true,
            draggable: true,
            hide: false,
        },
        autoHeight: false,
        loop: false,
        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
    });
}
